import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import layout from '@/store/modules/layout/index';
import user from '@/store/modules/user/index';
import home from '@/store/modules/home/index';
import classes from '@/store/modules/classes/index';
import payment from '@/store/modules/payment/index';
import board from '@/store/modules/board/index';
import scroll from '@/store/modules/scroll/index';

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    layout,
    user,
    home,
    classes,
    payment,
    board,
    scroll
  },
  // 새로고침해도 store 저장된 값이 날아가지 않도록 함
  plugins: [createPersistedState({ paths: ['user'] })]
});
